var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"input"},[_c('van-field',{attrs:{"name":_vm.inputNamel,"label":_vm.inputNamel,"placeholder":_vm.inputNamel},on:{"input":_vm.input},model:{value:(_vm.inputval),callback:function ($$v) {_vm.inputval=$$v},expression:"inputval"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }